import * as React from 'react';
import useEffect from './use_effect';

/**
 * The `useEventCallback` hook creates a memoized callback that only will be
 * rendered and called once it's required.
 * Its use is recommended with callbacks that contain
 * React.useRefs or callbacks that are called constantly.
 * See https://github.com/facebook/react/issues/14099 for more info.
 * @param callback
 */

var useEventCallback = callback => {
  var ref = React.useRef(callback);
  useEffect(() => {
    ref.current = callback;
  });
  return React.useCallback(function () {
    return ref.current(...arguments);
  }, []);
};
export default useEventCallback;